import { View, Flex, Link } from '@adobe/react-spectrum';
import { ComponentFactory } from '../../../../components/protected/layout-components/ComponentFactory';
import { FinderIcon } from '../../../../components/protected/Icons/IconsLib';
import { Loader } from './Loader';
import { MobileDetailViewProps } from '../types';
import styles from './MobileDetailView.module.css';

/**
 * MobileDetailView Component
 * 
 * Mobile detail view with header, status bar, and ComponentFactory content.
 * Displays detailed information about a selected activity.
 */
export function MobileDetailView({
  selectedItem,
  selectedDataRow,
  definition,
  isLoading,
  onBack,
  onOpenFinder,
  systemAttributes,
  getStatusColor,
}: MobileDetailViewProps) {
  return (
    <>
      <View position={'relative'} width={'100%'} height={'64px'} overflow={'hidden'} UNSAFE_className={styles.layout_header_parent}>
        <View position={'absolute'} top={'calc(50% - 14px)'} left={'15%'} UNSAFE_className={styles.layout_header_text}>
          {selectedItem?.item_type_name}
        </View>
        <View position={'absolute'} top={'calc(50% - 15px)'} left={'25px'} width={'24px'} height={'30px'} overflow={'hidden'} UNSAFE_className={styles.layout_header_btn_back}>
          <Link onPress={onBack}>
            <i className="bi bi-chevron-left fs-5" />
          </Link>
        </View>
        <View position={'absolute'} top={'calc(50% - 15px)'} right={'25px'} width={'24px'} height={'30px'} overflow={'hidden'}>
          <Link
            onPress={onOpenFinder}
            UNSAFE_className={styles.layout_header_btn_folder}
          >
            <FinderIcon size={24} />
          </Link>
        </View>
      </View>
      <Flex direction="column" alignItems={'center'} justifyContent={'center'} UNSAFE_className={styles.detailsHolder}>
        {selectedItem && (
          <>
            {isLoading ? (
              <Loader />
            ) : (
              <>
                <View
                  UNSAFE_className={styles.service_status_bar}
                  marginBottom={'5px'}
                  marginTop={'0px'}
                  UNSAFE_style={{ backgroundColor: getStatusColor(selectedDataRow?.customStateName ?? '') }}
                />
                <View width={'100%'} padding={'20px'}>
                  <ComponentFactory
                    key={selectedDataRow?.id ?? 'detail'}
                    selectedItem={selectedItem}
                    definition={definition}
                    systemAttributes={systemAttributes as unknown as any}
                  />
                </View>
              </>
            )}
          </>
        )}
      </Flex>
    </>
  );
}

